module.exports = __webpack_public_path__ + "static/media/HKGrotesk-Regular.4ff9d63c.ttf";